import type { ComponentChildren, FunctionComponent } from "preact";
import { useMergedClassName } from "../utils.ts";
import { Icon } from "../icon/icon.tsx";

export type DataGridColumn<T> = {
    key: string;
    title: string;
    render?: (item: T) => ComponentChildren;
    width?: string;
    align?: "left" | "center" | "right";
};

type DataGridProps<T> = {
    columns: DataGridColumn<T>[];
    data: T[];
    keyField: keyof T;
    emptyText?: string;
    loading?: boolean;
    class?: string;
};

export function DataGrid<T>(props: DataGridProps<T>) {
    const className = useMergedClassName("farpov_data_grid", props.class);
    
    return (
        <div class={className}>
            <div class="farpov_data_grid_wrapper">
                <table>
                    <thead>
                        <tr>
                            {props.columns.map((col) => (
                                <th 
                                    key={col.key} 
                                    style={{ width: col.width, textAlign: col.align || "left" }}
                                >
                                    {col.title}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {props.loading ? (
                            <tr>
                                <td colSpan={props.columns.length} class="farpov_data_grid_loading">
                                    <span aria-busy="true">Loading...</span>
                                </td>
                            </tr>
                        ) : props.data.length > 0 ? (
                            props.data.map((item) => (
                                <tr key={String(item[props.keyField])}>
                                    {props.columns.map((col) => (
                                        <td 
                                            key={col.key}
                                            style={{ textAlign: col.align || "left" }}
                                            data-label={col.title}
                                        >
                                            {col.render ? col.render(item) : (item as any)[col.key]}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={props.columns.length} class="farpov_data_grid_empty">
                                    <Icon name="inbox" />
                                    <p>{props.emptyText || "No data available"}</p>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
